"use client";

import { useState } from "react";
import { InputMode } from "../InputMode";
import { EmailIcon, NameIcon, PhoneIcon } from "@/assets/icons";
import toast from "react-hot-toast";

const Contactform = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contact: "",
    message: "",
  });

  const [errorData, setErrorData] = useState({
    firstName: false,
    lastName: false,
    email: false,
    contact: false,
  })

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // Validate inputs
    const newErrors = {
      firstName: formData.firstName.trim() === "",
      lastName: formData.lastName.trim() === "",
      email: formData.email.trim() === "",
      contact: formData.contact.trim() === "",
    };
    setErrorData(newErrors);

    const hasError = Object.values(newErrors).some((val) => val === true);
    if (hasError) return;

    const res = await fetch('/api/send-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    });

    const data = await res.json();

    if (data.status === 200) {
      toast.success(data.message);
    } else {
      toast.error(data.message);
    }
  };

  const handleInputChange = (inputName: string, value: string) => {
    setFormData({ ...formData, [inputName]: value });

    // Remove the error if value is entered
    if (value.trim() !== "") {
      setErrorData((prevErrors) => ({
        ...prevErrors,
        [inputName]: false,
      }));
    }
  };

  return (
    <div className="w-full ">
      <form onSubmit={handleSubmit}>

        <div className="bg-[#3C51A00D] p-4 lg:p-9  rounded-xl flex flex-col gap-5">
          <div className="grid sm:grid-cols-2 grid-cols-1 lg:grid-cols-1 xl:grid-cols-2 gap-5">
            <InputMode
              type="text"
              icon={<NameIcon />}
              title="First Name"
              placeholder="Devid"
              handleInputChange={handleInputChange}
              inputName="firstName"
              isShowError={errorData.firstName}
            />
            <InputMode
              type="text"
              icon={<NameIcon />}
              title="Last Name"
              placeholder=" Jhon"
              handleInputChange={handleInputChange}
              inputName="lastName"
              isShowError={errorData.lastName}
            />
            <InputMode
              type="email"
              icon={<EmailIcon />}
              placeholder="info@yourmai.com"
              title="Email"
              handleInputChange={handleInputChange}
              inputName="email"
              isShowError={errorData.email}
            />
            <InputMode
              type="number"
              icon={<PhoneIcon />}
              title="Contact Number"
              placeholder="1234567890"
              handleInputChange={handleInputChange}
              inputName="contact"
              isShowError={errorData.contact}
            />
          </div>
          <InputMode
            type="text"
            isTextarea={true}
            rows={4}
            title="Message"
            placeholder="Write your thoughts"
            isRequired={false}
            handleInputChange={handleInputChange}
            inputName="message"
          />
          <button className="btn  w-full sm:w-32 xl:w-32">Submit</button>
        </div>

      </form>
    </div>
  );
};

export default Contactform;
